import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/components/eventBus.js